import type { Language } from '@offer-catalog/services/i18n'
import type { VpAssetName } from '@vtmn-play/react'
import { storageHelper } from '@offer-catalog/logic'
import { changeLanguage, getCurrentLanguage } from '@offer-catalog/services/i18n'
import { VpAsset, VpIcon } from '@vtmn-play/react'
import clsx from 'clsx'
import { useTranslation } from 'react-i18next'
import { useFlyoutMenu } from '@/hooks'
import './languageSwitcher.scss'

export function LanguageSwitcher() {
  const { t } = useTranslation()
  const currentLanguage = getCurrentLanguage()

  const { flyoutWrapperRef, toggleFlyout, isOpened, setIsOpened }
    = useFlyoutMenu()

  const switchLanguage = (lang: Language) => {
    void changeLanguage(lang)
    storageHelper.setItem('cat_loc', lang === 'fr' ? 'fr-FR' : 'en-GB')
    setIsOpened(false)
  }

  const languages: Language[] = ['en', 'fr']
  const flag: { [key in Language]: VpAssetName } = { en: 'flag-gb', fr: 'flag-fr' }
  const flagIconName = flag[currentLanguage]

  return (
    <div
      className="flags-dropdown-container"
      data-testid="flags-dropdown-container"
      ref={flyoutWrapperRef}
    >
      <button
        type="button"
        className="chosen-language"
        data-testid="chosen-language"
        aria-label={t('aria-label.language-switcher-current', {
          language: t(`aria-label.language-name-${currentLanguage}`),
        })}
        onClick={toggleFlyout}
        onKeyDown={toggleFlyout}
      >
        <VpAsset name={flagIconName} width={26} />
        <VpIcon name={`chevron-${isOpened ? 'up' : 'down'}`} size={20} />
      </button>
      <div
        className={clsx('flags-dropdown', { show: isOpened })}
        data-testid="flags-dropdown"
      >
        {languages.map(lang => (
          <button
            type="button"
            className={clsx('flag-line', {
              selected: lang === currentLanguage,
            })}
            data-testid={`flag-${lang}`}
            key={lang}
            onClick={() => switchLanguage(lang)}
            onKeyDown={() => switchLanguage(lang)}
          >
            <div>
              {lang === currentLanguage && <VpIcon name="check" size={16} />}
            </div>
            <VpAsset name={flag[lang]} />
            <div>
              {lang.toUpperCase()}
              {' - '}
              {t(`language-options.${lang}`)}
            </div>
          </button>
        ))}
      </div>
    </div>
  )
}
